import { memo } from 'react';

export enum ArrowDirection {
  Up = 'up',
  Down = 'down',
}

interface ArrowAnimationProps {
  /** Direction of arrow movement */
  direction?: ArrowDirection;
  /** Animation duration in seconds (default: 1.5) */
  duration?: number;
  /** Delay before animation starts in seconds (default: 0) */
  delay?: number;
  /** Vertical movement distance in pixels (default: 8) */
  moveDistance?: number;
}

function ArrowAnimation({
  direction = ArrowDirection.Down,
  duration = 1.5,
  delay = 0,
  moveDistance = 8,
}: ArrowAnimationProps) {
  // Calculate motion path based on direction:
  // - Up: starts at default position, moves up (sunrise - arrow emerges upward)
  // - Down: starts above default, moves down to default (sunset - arrow descends)
  const motionPath =
    direction === ArrowDirection.Up
      ? `M0,0 L0,${-moveDistance}` // Start at default, move up
      : `M0,${-moveDistance} L0,0`; // Start above, move down to default

  return (
    <>
      {/* Opacity: fade in, hold, fade out */}
      <animate
        attributeName="opacity"
        values="0; 1; 1; 0"
        keyTimes="0; 0.1; 0.9; 1"
        dur={`${duration}s`}
        begin={`${delay}s`}
        repeatCount="indefinite"
        calcMode="spline"
        keySplines="0.4 0 0.6 1; 0.5 0 0.5 1; 0.4 0 0.6 1"
      />
      {/* Vertical motion in arrow direction */}
      <animateMotion
        path={motionPath}
        dur={`${duration}s`}
        begin={`${delay}s`}
        repeatCount="indefinite"
        calcMode="spline"
        keySplines="0.4 0 0.6 1"
      />
    </>
  );
}

export default memo(ArrowAnimation);
